import React, { useEffect } from 'react';
import { StatusBar } from 'react-native';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// import RootNavigator from './navigation/RootNavigator';
import HomeScreen from './screens/Home/HomeSimple';
import { useAuthStore, useLotteryStore } from './stores';
import { COLORS } from './utils/constants';

// 创建 React Query 客户端
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export default function App() {
  const { loadAuthState } = useAuthStore();
  const { loadLotteryType } = useLotteryStore();

  useEffect(() => {
    // 应用启动时加载状态
    const initApp = async () => {
      await Promise.all([
        loadAuthState(),
        loadLotteryType(),
      ]);
    };
    initApp();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <GestureHandlerRootView style={{ flex: 1 }}>
        <SafeAreaProvider>
          <StatusBar
            barStyle="light-content"
            backgroundColor={COLORS.PRIMARY}
          />
          {/* <RootNavigator /> */}
          <HomeScreen />
        </SafeAreaProvider>
      </GestureHandlerRootView>
    </QueryClientProvider>
  );
}
